import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type Props = {
  readonly value: number;
  readonly index: number;
  readonly children: ReactNode;
};

const TabPanel = (props: Props) => {
  const { children, value, index, ...other } = props;

  return (
    <div role='tabpanel' hidden={value !== index} {...other}>
      {value === index && (
        <Box p={3} style={{ padding: 0 }}>
          <Typography component='span'>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default TabPanel;
